import FlashOnIcon from "@mui/icons-material/FlashOn";
import TuneIcon from "@mui/icons-material/Tune";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";

type Props = {
  mode: "quick" | "advanced";
  onChange: (mode: "quick" | "advanced") => void;
};

export function FilterModeSwitch({ mode, onChange }: Props) {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={mode}
      onChange={(_e, val) => val && onChange(val)}
    >
      <Tooltip title={t("common.quickFilters")}>
        <ToggleButton value="quick" aria-label="Quick filters">
          <FlashOnIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>

      <Tooltip title={t("common.advancedFilters")}>
        <ToggleButton value="advanced" aria-label="Advanced filters">
          <TuneIcon fontSize="small" />
        </ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
}
